module.exports = __webpack_public_path__ + "img/caratula_mas al sur_2.68cfba4a.jpg";